/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useCallback, useState, type Dispatch, type SetStateAction } from 'react';

export const useOpenable = (
	initialState = false,
): {
	isOpen: boolean;
	onClose: () => void;
	onOpen: () => void;
	onToggle: () => void;
	setIsOpen: Dispatch<SetStateAction<boolean>>;
} => {
	const [isOpen, setIsOpen] = useState(initialState);
	const onClose = useCallback((): void => setIsOpen(false), [setIsOpen]);
	const onOpen = useCallback((): void => setIsOpen(true), [setIsOpen]);
	const onToggle = useCallback((): void => setIsOpen((value) => !value), [setIsOpen]);

	return { isOpen, onClose, onOpen, onToggle, setIsOpen };
};
